import React from 'react';
import { 
  Dialog, 
  Classes, 
  Button, 
  Intent,
  Icon,
  Divider
} from '@blueprintjs/core';

/**
 * Reusable Modal component that can be used across the application
 * Provides consistent styling and behavior for all dialogs
 */
class Modal extends React.Component {
  render() {
    const {
      isOpen = false,
      onClose,
      title,
      children,
      footer,
      primaryButtonText = "Close",
      primaryButtonIntent = Intent.PRIMARY,
      onPrimaryButtonClick,
      secondaryButtonText,
      secondaryButtonIntent = Intent.NONE,
      onSecondaryButtonClick,
      width = "500px",
      height,
      canEscapeKeyClose = true,
      canOutsideClickClose = true,
      showCloseButton = true,
      isCloseButtonShown = true,
      className = "",
      style = {},
      bodyStyle = {},
      footerStyle = {},
      headerStyle = {}
    } = this.props;

    const modalStyle = {
      width,
      borderRadius: '12px',
      ...style
    };

    if (height) {
      modalStyle.height = height;
    }

    // Custom footer or default footer
    const modalFooter = footer || (
      <div 
        className={Classes.DIALOG_FOOTER}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          padding: '16px 24px',
          borderTop: '1px solid #394b59',
          ...footerStyle
        }}
      >
        {secondaryButtonText && (
          <Button
            intent={secondaryButtonIntent}
            onClick={onSecondaryButtonClick || onClose}
            style={{ borderRadius: '6px' }}
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button
          intent={primaryButtonIntent}
          onClick={onPrimaryButtonClick || onClose}
          style={{ borderRadius: '6px', fontWeight: 600 }}
        >
          {primaryButtonText}
        </Button>
      </div>
    );

    return (
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        title={
          title && (
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px',
                padding: '20px 24px 16px',
                borderBottom: '1px solid #394b59',
                ...headerStyle
              }}
            >
              {typeof title === 'string' ? (
                <span style={{ fontSize: '18px', fontWeight: 600 }}>{title}</span>
              ) : (
                title
              )}
            </div>
          )
        }
        canEscapeKeyClose={canEscapeKeyClose}
        canOutsideClickClose={canOutsideClickClose}
        isCloseButtonShown={showCloseButton && isCloseButtonShown}
        className={`custom-modal ${className}`}
        style={modalStyle}
      >
        <div 
          className={Classes.DIALOG_BODY}
          style={{
            padding: '20px 24px',
            maxHeight: height ? `calc(${height} - 140px)` : '60vh',
            overflowY: 'auto',
            ...bodyStyle
          }}
        >
          {children}
        </div>
        {modalFooter}
      </Dialog>
    );
  }
}

export default Modal;
